import VideoBackgroundEditor from './VideoBackgroundEditor';

export default VideoBackgroundEditor;
